import env from 'lib/env';

export const AUTH_SESSION_CONFIG = {
  session_duration_minutes: env.NEXT_PUBLIC_AUTH_DURATION_MINUTES,
} as const;

export const TOKEN_TYPES = {
  MAGIC_LINK: 'multi_tenant_magic_links',
  SSO: 'sso',
  DISCOVERY_MAGIC_LINK: 'discovery',
  DISCOVERY_OAUTH: 'discovery_oauth',
} as const;

export type TokenType = (typeof TOKEN_TYPES)[keyof typeof TOKEN_TYPES];

export const LOGIN_TOKEN_TYPES = [TOKEN_TYPES.SSO, TOKEN_TYPES.MAGIC_LINK] as const;

export const DISCOVERY_TOKEN_TYPES = [TOKEN_TYPES.DISCOVERY_MAGIC_LINK, TOKEN_TYPES.DISCOVERY_OAUTH] as const;
